import { useQuery, useQueryClient } from '@tanstack/react-query';
import { meApi } from '@/api/endpoints';

export const ME_QUERY_KEY = ['me'] as const;

export function useMe() {
  return useQuery({
    queryKey: ME_QUERY_KEY,
    queryFn: meApi.getMe,
    staleTime: 30_000,      // balances can change on every bet; 30s is a reasonable floor
    retry: false,           // 401 means logged out, not a transient failure
  });
}

/** Imperatively invalidate the /me cache — call after any write that
 *  changes balances (bet placement, deposit, withdrawal). */
export function useInvalidateMe() {
  const qc = useQueryClient();
  return () => qc.invalidateQueries({ queryKey: ME_QUERY_KEY });
}
